import r from "../../shared-lib/braze-shared-lib.js";
export default class _t {
  constructor(t, i, s) {
    (this.iu = t),
      null == t && (t = r.Z.Y()),
      !s || isNaN(s) ? (this.vl = new Date().valueOf()) : (this.vl = s),
      (this.iu = t),
      (this.Nl = new Date().valueOf()),
      (this.Gl = i);
  }
  ss() {
    return { g: this.iu, e: this.Gl, c: this.vl, l: this.Nl };
  }
  static Yn(t) {
    if (null == t || null == t.g) return null;
    const i = new _t(t.g, t.e, t.c);
    return (i.Nl = t.l), i;
  }
}
